
import '../styles/App.css';
import '../styles/pages/Mission.css';

import CustomText from '../components/Text';
import Header from '../components/Header';

function Mission() {
  return (
    <div id="mission" className="section" style={{background: "#FFFFFF"}}>
      <div className="missionWrapper">
        <Header content="A Nossa Missão" />
        <CustomText
          type="desc"
          content="A nossa missão é fornecer serviços de qualidade na área da Saúde Psicológica, que integrem uma perspetiva ecológica e ambiental ao oferecer serviços integrados na comunidade. Procuramos oferecer facilidade de acesso aos serviços e um ambiente seguro e acolhedor, onde cada pessoa possa enfrentar os seus desafios emocionais, relacionais e profissionais. Ao adotar uma abordagem terapêutica abrangente e personalizada, o nosso consultório promove o bem-estar emocional, relacional e profissional dos nossos clientes, visando uma melhoria significativa na sua qualidade de vida."
        />
     </div> 
    </div> 
  );
}

export default Mission;
